import { gql } from '@apollo/client';
import {
  USER_SETTINGS_CHANGE_START,
  USER_SETTINGS_CHANGE_SUCCESS,
  USER_SETTINGS_CHANGE_ERROR,
} from 'constants/index';

const MUTATION = {
  CHANGE_USER_SETTINGS: gql`
    mutation UpdateUserSettings($settings: UserSettings) {
      UpdateUserSettings(settings: $settings) {
        home_connect_enabled
        home_connect_token
        home_connect_preferred_oven
        home_country
        temperature_unit
        oven_brands
        unit_system
      }
    }
  `,
};

export default function changeSettings(settings) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: USER_SETTINGS_CHANGE_START,
      payload: settings,
    });

    try {
      const { data, errors } = await client.mutate({
        mutation: MUTATION.CHANGE_USER_SETTINGS,
        variables: { settings },
      });

      if (errors && errors.length > 0) {
        dispatch({
          type: USER_SETTINGS_CHANGE_ERROR,
          payload: {
            errors: errors[0].graphQLErrors,
          },
        });
      } else {
        await dispatch({
          type: USER_SETTINGS_CHANGE_SUCCESS,
          payload: data.UpdateUserSettings,
        });
        try {
          localStorage.setItem('user', JSON.stringify({ ...getState().user, collections: {} }));
        } catch (error) {
          console.error('Failed to store user', error);
        }
      }
    } catch (error) {
      dispatch({
        type: USER_SETTINGS_CHANGE_ERROR,
        payload: {
          errors: error.graphQLErrors,
        },
      });
    }
  };
}
